import './App.css';
import MainBody from "./components/MainBody";
import InputArea from "./components/InputArea";
import Result from "./components/Result";
import { useState } from "react";

function App() {
    const [answer, setAnswer] = useState('');

    return (
        <div className="App">
            <MainBody />
            <InputArea setAnswer={setAnswer} answer={answer} />
            <Result answer={answer} />
        </div>
    );
}

export default App;
